import { Permission } from 'api';
import { RouteDefinition } from './types';

export const getExaminerRoutes = (basePath: string) => {
  return {
    path: `${basePath}`,
    details: {
      to: `${basePath}`,
      path: ``,
      requiresAny: [Permission.ViewExaminerDetails, Permission.EditExaminerDetails],
    } as RouteDefinition,
    contactDetails: {
      to: `${basePath}/contact-details`,
      path: `contact-details`,
      requiresAny: [Permission.ViewExaminerContactDetails, Permission.EditExaminerContactDetails],
    } as RouteDefinition,

    centres: getExaminerCentresRoutes(`${basePath}/centres`),

    certification: {
      to: `${basePath}/certifications`,
      path: `certifications`,
      requiresAny: [Permission.UpdateCertificationHistory, Permission.ViewCertificationHistory],
      speaking: {
        to: `${basePath}/certifications/speaking`,
        path: `speaking`,
        requiresAny: [Permission.ViewCertificationHistory, Permission.UpdateCertificationHistory],
        add: {
          to: `${basePath}/certifications/speaking/add`,
          path: `add`,
          requiresAny: [Permission.UpdateCertificationHistory],
        } as RouteDefinition,
        details: {
          to: `${basePath}/certifications/speaking/:certificationId`,
          path: `:certificationId`,
          requiresAny: [Permission.UpdateCertificationHistory, Permission.ViewCertificationHistory],
        } as RouteDefinition,
      },
      writing: {
        to: `${basePath}/certifications/writing`,
        path: `writing`,
        requiresAny: [Permission.ViewCertificationHistory, Permission.UpdateCertificationHistory],
        add: {
          to: `${basePath}/certifications/writing/add`,
          path: `add`,
          requiresAny: [Permission.UpdateCertificationHistory],
        } as RouteDefinition,
        details: {
          to: `${basePath}/certifications/writing/:certificationId`,
          path: `:certificationId`,
          requiresAny: [Permission.UpdateCertificationHistory, Permission.ViewCertificationHistory],
        } as RouteDefinition,
      },
      lifeSkills: {
        to: `${basePath}/certifications/lifeskills`,
        path: `lifeskills`,
        requiresAny: [Permission.ViewCertificationHistory, Permission.UpdateCertificationHistory],
        add: {
          to: `${basePath}/certifications/lifeskills/add`,
          path: `add`,
          requiresAny: [Permission.UpdateCertificationHistory],
        } as RouteDefinition,
        details: {
          to: `${basePath}/certifications/lifeskills/:certificationId`,
          path: `:certificationId`,
          requiresAny: [Permission.UpdateCertificationHistory, Permission.ViewCertificationHistory],
        } as RouteDefinition,
      },
    },
    odpAssessment: {
      to: `${basePath}/odp-assessment`,
      path: `odp-assessment`,
      requiresAny: [Permission.ViewOdp],
      add: {
        to: `${basePath}/odp-assessment/add`,
        path: `add`,
        requiresAny: [Permission.AddOdp],
      },
      details: {
        to: `${basePath}/odp-assessment/:assessmentId`,
        path: `:assessmentId`,
        requiresAny: [Permission.ViewOdp],
      },
    },
    monitoring: {
      to: `${basePath}/monitorings`,
      path: `monitorings`,
      requiresAny: [Permission.UpdateMonitoringResults, Permission.ViewMonitoringResults],
    } as RouteDefinition,
    trainingAndStandardisation: {
      to: `${basePath}/standardisations`,
      path: `standardisations`,
      requiresAny: [Permission.UpdateStandardisationHistory, Permission.ViewStandardisationHistory],
      add: {
        to: `${basePath}/standardisations/add`,
        path: `add`,
        requiresAny: [Permission.UpdateStandardisationHistory],
      },
      details: {
        to: `${basePath}/standardisations/:trainingId`,
        path: `:trainingId`,
        requiresAny: [
          Permission.UpdateStandardisationHistory,
          Permission.ViewStandardisationHistory,
        ],
      },
    },
    disciplinary: {
      to: `${basePath}/disciplinary`,
      path: `disciplinary`,
      requiresAny: [Permission.ViewDisciplinary, Permission.EditDisciplinary],
      add: {
        to: `${basePath}/disciplinary/add`,
        path: `add`,
        requiresAny: [Permission.EditDisciplinary],
      },
    },
    documents: {
      to: `${basePath}/documents`,
      path: `documents`,
      requiresAny: [Permission.UpdateExaminerDocuments, Permission.ViewExaminerDocuments],
      add: {
        to: `${basePath}/documents/:documentCategory/add`,
        path: `:documentCategory/add`,
        requiresAny: [Permission.UpdateExaminerDocuments],
      },
    },
    communication: {
      to: `${basePath}/communication`,
      path: `communication`,
      requiresAny: [Permission.ViewExaminerCommunication],
    } as RouteDefinition,
  };
};

function getExaminerCentresRoutes(basePath: string) {
  return {
    path: `centres`,
    requiresAny: [
      Permission.EditExaminerCentreRelationships,
      Permission.ViewExaminerCentreRelationships,
    ],
    speaking: {
      to: `${basePath}/speaking`,
      path: 'speaking',
    },
    writing: {
      to: `${basePath}/writing`,
      path: 'writing',
    },
    lifeSkills: {
      to: `${basePath}/lifeSkills`,
      path: 'lifeSkills',
    },
  };
}
